import { ClientFlags, OnboardingTrialStepsType } from '@sdk/authentication/types';
import type { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';

import type { Event } from '@web/onboarding/Checklist/onboardingChecklist.types';
import type { CompleteStep } from '@web/onboarding/Checklist/hooks/useCompleteStep';
import type {
  RestangularEmployee,
  RestangularPosition,
} from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import useAutocompleteAddEmployeeStep from '@web/onboarding/Checklist/hooks/useAutocompleteAddEmployeeStep';
import useAutocompleteCreateShiftsStep from '@web/onboarding/Checklist/hooks/useAutocompleteCreateShiftsStep';
import useAutocompletePublishScheduleStep from '@web/onboarding/Checklist/hooks/useAutocompletePublishScheduleStep';
import useAutocompleteEnableTimeClockStep from '@web/onboarding/Checklist/hooks/useAutocompleteEnableTimeClockStep';
import useAutocompleteDefineEmployeeWagesStep from '@web/onboarding/Checklist/hooks/useAutocompleteDefineEmployeeWagesStep';

type Props = {
  availableSteps: OnboardingTrialStepsType[];
  completeStep: CompleteStep;
  clientFlags: ClientFlags;
  personasDict: PersonasDict;
  allEvents: Event[];
  isTimeTrackingEnabled: boolean;
  employees: RestangularEmployee[];
  positions: RestangularPosition[];
};
const useAutocompleteSteps = ({
  availableSteps,
  completeStep,
  clientFlags,
  personasDict,
  allEvents,
  isTimeTrackingEnabled,
  employees,
  positions,
}: Props) => {
  useAutocompleteCreateShiftsStep({
    availableSteps,
    completeStep,
    clientFlags,
    allEvents,
  });

  useAutocompletePublishScheduleStep({
    availableSteps,
    completeStep,
    clientFlags,
    allEvents,
  });

  useAutocompleteAddEmployeeStep({
    availableSteps,
    completeStep,
    clientFlags,
    personasDict,
  });

  useAutocompleteEnableTimeClockStep({
    availableSteps,
    completeStep,
    clientFlags,
    isTimeTrackingEnabled,
  });

  useAutocompleteDefineEmployeeWagesStep({
    availableSteps,
    completeStep,
    clientFlags,
    employees,
    positions,
  });
};

export default useAutocompleteSteps;
